<template>
	<div class="reviewListContainer" v-if="ptInitData.reviewList != null && ptInitData.reviewList.length > 0">
		<div class="reviewListTitle">
			<span class="itemReviewTitle">
				{{ $t('pt125.labels.itemReviewTitle') }}
			</span>
			<span class="itemReviewEn">
				{{ $t('pt125.labels.itemReviewEn') }}
			</span>
		</div>
		<div class="reviewListHeader">
			<div class="reviewAllQtyHeader">
				{{ ($t('pt125.labels.reviewAllQty')).replace("{0}", ptInitData.productInfo.REVIEW_QTY) }}
			</div>
			<div class="reviewAllHeader">
				<router-link class="reviewAll"
					:to="{ name: SiteConstants.PG010MAIN, query: { pageNo: 84, processKbn: 1, itemCd: ptInitData.productInfo.S_ITEM_NO } }">
					{{ $t('pt125.labels.reviewAll') }}
				</router-link>

			</div>
		</div>
		<div id="readMoreBlock">
			<div class="reviewList readMoreInner" v-for="(reviewItem, index) in ptInitData.reviewList" :key="index">
				<div class="readMoreContainer">
					<div class="reviewItem">
						<div class="reviewItemHeader">
							<span class="reviewTitle">{{ reviewItem.TITLE }}</span>
							&nbsp;
							<span class="nickName">
								{{ $t('pt125.labels.reviewKokyakuGroup') }}
								<router-link
									:to="{ name: SiteConstants.PG010MAIN, query: { pageNo: 84, processKbn: 2, kokyakuNo: reviewItem.KOKYAKU_NO } }">
									{{ reviewItem.NICKNAME }}
								</router-link>
							</span>
							&nbsp;
							<span class="reviewKokyakuGroup" v-if="reviewItem.KOKYAKU_GROUP">
								{{ reviewItem.KOKYAKU_GROUP }}
							</span>
							<span class="kokyakuAge" v-if="reviewItem.AGE_OPEN_FLG && reviewItem.KOKYAKU_AGE">
								<template v-if="reviewItem.KOKYAKU_AGE < 10">{{
									$t('pt125.labels.Oblique') }}00{{ $t('pt125.labels.ageAfterWord')
									}}</template>
								<template v-else-if="reviewItem.KOKYAKU_AGE >= 100">{{
									$t('pt125.labels.Oblique') }}{{
										reviewItem.KOKYAKU_AGE.toString().substring(1, 2) }}0{{
										$t('pt125.labels.ageAfterWord') }}</template>
								<template v-else>{{ $t('pt125.labels.Oblique') }}{{
									reviewItem.KOKYAKU_AGE.toString().substring(0, 1) }}0{{
										$t('pt125.labels.ageAfterWord') }}</template>
							</span>
							<span class="kokyakuSex" v-if="reviewItem.SEX_OPEN_FLG && reviewItem.KOKYAKU_SEX_KBN_NM">
								{{ $t('pt125.labels.Oblique') }}{{ reviewItem.KOKYAKU_SEX_KBN_NM }}
							</span>
							<span class="reviewItemStar">
								<template v-if="reviewItem.TOTALRANKAVG >= 1 && reviewItem.TOTALRANKAVG <= 10">
									<img class="imgReviewItem" src="../img/icons/demo/star_0_5.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 11 && reviewItem.TOTALRANKAVG <= 20">
									<img class="imgReviewItem" src="../img/icons/demo/star_1.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 21 && reviewItem.TOTALRANKAVG <= 30">
									<img class="imgReviewItem" src="../img/icons/demo/star_1_5.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 31 && reviewItem.TOTALRANKAVG <= 40">
									<img class="imgReviewItem" src="../img/icons/demo/star_2.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 41 && reviewItem.TOTALRANKAVG <= 50">
									<img class="imgReviewItem" src="../img/icons/demo/star_2_5.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 51 && reviewItem.TOTALRANKAVG <= 60">
									<img class="imgReviewItem" src="../img/icons/demo/star_3.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 61 && reviewItem.TOTALRANKAVG <= 70">
									<img class="imgReviewItem" src="../img/icons/demo/star_3_5.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 71 && reviewItem.TOTALRANKAVG <= 80">
									<img class="imgReviewItem" src="../img/icons/demo/star_4.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 81 && reviewItem.TOTALRANKAVG <= 90">
									<img class="imgReviewItem" src="../img/icons/demo/star_4_5.png">
								</template>
								<template v-if="reviewItem.TOTALRANKAVG >= 91 && reviewItem.TOTALRANKAVG <= 100">
									<img class="imgReviewItem" src="../img/icons/demo/star_5.png">
								</template>
							</span>
						</div>
						<div class="reviewItemContentInfo">
							<div class="reviewContent">
								<span :id="'reviewItemContent' + index" class="reviewItemContent"
									v-html="reviewItem.REVIEW"></span>
							</div>
							<!--画像-->
							<div class="reviewImgContainer"
								v-if="reviewItem.IMAGE1 || reviewItem.IMAGE2 || reviewItem.IMAGE3">
								<div class="reviewImgList" v-if="reviewItem.IMAGE1">
									<img class="reviewImg1" :src="reviewItem.IMAGE1" @error="getErrImage">
								</div>
								<div class="reviewImgList" v-if="reviewItem.IMAGE2">
									<img class="reviewImg2" :src="reviewItem.IMAGE2" @error="getErrImage">
								</div>
								<div class="reviewImgList" v-if="reviewItem.IMAGE3">
									<img class="reviewImg3" :src="reviewItem.IMAGE3" @error="getErrImage">
								</div>
							</div>
							<div class="reviewDate">
								{{ reviewItem.POST_YMD }}
							</div>
						</div>
					</div>
					<div class="reviewReplyInfo" v-if="reviewItem.REPLY_DISP_FLG == 1 && reviewItem.REPLY">
						<div class="replayImageInfo">
							↳<span class="reviewReplyContent" v-html="reviewItem.REPLY" />
						</div>
						<div class="replyDate">
							{{ reviewItem.REPLY_YMD }}
						</div>
					</div>
				</div>
				<button class="readMoreBtn">
					{{ $t('pt125.labels.reviewItemReadAll') }}
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import SiteConstants from 'assets/const/SiteConstants.json';
import common from "assets/js/common";
export default {
	name: 'ReviewListContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			SiteConstants
		}
	},
	methods: {
		/**
			 * exec load url default when load main image is error
			 * @param {Any} event, event exec error
			 */
		getErrImage(event) {
			//get image default
			event.target.src = common.getImgDefault();
		},
	},
}
</script>